import { useState, useCallback } from 'react';
import { ApiClient } from '../api/apiClient';

// Usar la misma configuración que useInvoicePortal
const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/';
const apiClient = new ApiClient({
  baseURL: baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL,
});

interface PaymentLinkResponse {
  payment_url: string;
  expires_at: string;
}

interface UsePaymentLinkResult {
  createPaymentLink: (invoiceId: number) => Promise<void>;
  isLoading: boolean;
  error: string | null;
  clearError: () => void;
}

export const usePaymentLink = (): UsePaymentLinkResult => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createPaymentLink = useCallback(async (invoiceId: number) => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await apiClient.createPaymentLink(invoiceId);
      const { payment_url } = response.data;

      // Redirigir al usuario al link de pago
      window.location.href = payment_url;
    } catch (err: any) {
      console.error('Error creating payment link:', err);

      if (err.status === 404) {
        setError('Factura no encontrada');
      } else if (err.status === 400) {
        setError('Datos de factura inválidos');
      } else {
        setError(err.message || 'Error al crear el link de pago');
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    createPaymentLink,
    isLoading,
    error,
    clearError,
  };
};
